import { emptyApi } from "store/apis/emptyApi";
import {
  ONBOARDING_STEP_KEY,
  OnboardingStepKey,
} from "v2/constants/onboardingStepKey";

export type OnboardingState = {
  completedSteps: OnboardingStepKey[];
  formationTypeId: string;
};

type ApiOnboardingState = {
  completed_steps: string[];
  formation_type_id: string | null;
};

type ApiOnboardingStateInput = {
  completed_steps: string[];
  formation_type_id?: string;
};

const KNOWN_STEP_KEYS: string[] = Object.values(ONBOARDING_STEP_KEY);

const isStepKey = (value: string): value is OnboardingStepKey =>
  KNOWN_STEP_KEYS.includes(value);

const toOnboardingState = (response: ApiOnboardingState): OnboardingState => ({
  completedSteps: (response.completed_steps ?? []).filter(isStepKey),
  formationTypeId: response.formation_type_id ?? "",
});

const toApiOnboardingState = (
  state: OnboardingState
): ApiOnboardingStateInput => ({
  completed_steps: state.completedSteps,
  ...(state.formationTypeId
    ? { formation_type_id: state.formationTypeId }
    : {}),
});

export const onboardingStateApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getOnboardingState: build.query<OnboardingState, void>({
      query: () => ({ url: "api/inkle/platform/v2/onboarding/state/" }),
      transformResponse: toOnboardingState,
      providesTags: ["ONBOARDING_STATE"],
    }),

    saveOnboardingState: build.mutation<OnboardingState, OnboardingState>({
      query: (state) => ({
        url: "api/inkle/platform/v2/onboarding/state/",
        method: "PUT",
        body: toApiOnboardingState(state),
      }),
      transformResponse: toOnboardingState,
      invalidatesTags: ["ONBOARDING_STATE"],
    }),
  }),
});

export const { useGetOnboardingStateQuery, useSaveOnboardingStateMutation } =
  onboardingStateApi;
